/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useAuth } from '../../../../../app/modules/auth'
// import {roleValues} from '../../../../../app/core/_constants'
import { useModuleStatus } from '../../../../../app/hooks/useModuleStatus'
import brandingConfig from '../../../../../config/brandingConfig'
// import { toAbsoluteUrl } from '../../../../helpers'
// import LockIcon from '../../../../../media/Generic/ic-lock-black.svg'
import { plansRK } from '../../../../../app/modules/onboarding/core/_constants'
import { BillingModal } from '../../../../../app/modules/onboarding/views/BillingModal'

const SidebarMenuMainRecordskeeper = () => {
  const intl = useIntl()
  const { billingData, role } = useAuth() //eslint-disable-line
  const { moduleStatus } = useModuleStatus()
  const [isActive, setIsActive] = useState(false)
  const [currentState, setCurrentState] = useState<string>('Monthly')
  const [selected, setSelected] = useState('Gold')
  const [currencyBill, setCurrencyBill] = useState('USD') //eslint-disable-line
  const [price, setPrice] = useState(plansRK.find((p) => p.title === 'Gold')?.priceMonthUSD || '0') //eslint-disable-line
  return (
    <>
      {/* Dashboard  */}
      {moduleStatus['dashboard'] !== false && (
        <SidebarMenuItem
          to='/dashboard'
          icon='/media/icons/sidebar/v2/ic-dashboard.svg'
          activeIcon='/media/icons/sidebar/v2/ic-dashboard-active.svg'
          title={intl.formatMessage({ id: 'Dashboard' })}
          fontIcon='bi-app-indicator'
        />
      )}

      {/* RecordKeeper AI  */}
      {/* {moduleStatus['recordskeeper-ai'] !== false && role && role !== roleValues.BILLING && role !== roleValues.CURATOR && ( */}
      {moduleStatus['recordskeeper-ai'] !== false && (
        <SidebarMenuItemWithSub
          to='/rk'
          icon='/media/icons/sidebar/v2/ic-recordskeeper-ai.svg'
          title={intl.formatMessage({ id: 'RecordsKeeper AI' })}
          fontIcon='bi-person'
        >
          <SidebarMenuItem
            to='rk/overview'
            title={intl.formatMessage({ id: 'Overview' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='rk/records-and-files'
            title={intl.formatMessage({ id: 'Records & Files' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='rk/search-and-filters'
            title={intl.formatMessage({ id: 'Search & Filters' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='rk/sources-and-sync'
            title={intl.formatMessage({ id: 'Sources & Sync' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='rk/records-classifications'
            title={intl.formatMessage({ id: 'Records Classifications' })}
            hasBullet={true}
          />
          {/* <SidebarMenuItem
            to='rk/query-and-prompt'
            title={intl.formatMessage({ id: 'Query & Prompt' })}
            hasBullet={true}
          /> */}
          <SidebarMenuItem
            to='rk/analytics-and-reports'
            title={intl.formatMessage({ id: 'Analytics & Reports' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='rk/setting-and-policy'
            title={intl.formatMessage({ id: 'Setting & Policy' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='rk/audits-and-logs'
            title={intl.formatMessage({ id: 'Audits & Logs' })}
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )}

      {/* Query and prompt  */}
      {/* {moduleStatus['recordskeeper-ai'] !== false && role && role !== roleValues.BILLING && ( */}
      {moduleStatus['recordskeeper-ai'] !== false && (
        <SidebarMenuItem
          to='/query-and-prompt'
          icon='/media/icons/sidebar/v3/ic-rk-query-prompt.svg'
          activeIcon='/media/icons/sidebar/v3/ic-rk-query-prompt-active.svg'
          title={intl.formatMessage({ id: 'Query and Prompt' })}
          fontIcon='bi-layers'
        />
      )}

      {/* Data Rooms  */}
      {moduleStatus['dataroom'] !== false && (
        <SidebarMenuItemWithSub
          to='/data-rooms'
          title={intl.formatMessage({ id: 'Data Rooms' })}
          icon='/media/icons/sidebar/v2/ic-data-room.svg'
          fontIcon='bi-person'
        >
          {/* {role !== roleValues.BILLING && role !== roleValues.CURATOR && ( */}
          {
            <SidebarMenuItem
              to='/data-rooms/overview'
              title={intl.formatMessage({ id: 'Overview' })}
              hasBullet={true}
            />
          }
          {/* {role !== roleValues.BILLING && role !== roleValues.CURATOR && ( */}
          {
            <SidebarMenuItem
              to='/data-rooms/spaces'
              title={intl.formatMessage({ id: 'Data Rooms' })}
              hasBullet={true}
            />
          }
          {/* {role !== roleValues.BILLING && role !== roleValues.CURATOR && ( */}
          {
            <SidebarMenuItem
              to='/data-rooms/files'
              title={intl.formatMessage({ id: 'Files' })}
              hasBullet={true}
            />
          }
        </SidebarMenuItemWithSub>
      )}

      {/* Digital Sign  */}
      {/* {moduleStatus['digital-signing'] !== false &&
        role &&
        role !== roleValues.BILLING &&
        role !== roleValues.CURATOR && ( */}
      {moduleStatus['digital-signing'] !== false && (
        <SidebarMenuItemWithSub
          to=''
          title={intl.formatMessage({ id: 'Digital Signing' })}
          icon='/media/icons/sidebar/v2/ic-document-signed.svg'
          fontIcon='bi-person'
        >
          <SidebarMenuItem
            to='/digital-signing?tab=all-documents'
            title={intl.formatMessage({ id: 'All Documents' })}
            hasBullet={true}
          />

          <SidebarMenuItem
            to='/digital-signing?tab=templates'
            title={intl.formatMessage({ id: 'Templates' })}
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )}

      {/* Stakeholders  */}
      {moduleStatus['stakeholders'] !== false && (
        <SidebarMenuItemWithSub
          to='/stakeholders'
          title={intl.formatMessage({ id: 'Stakeholders' })}
          icon='/media/icons/sidebar/v2/ic-stakeholder.svg'
          fontIcon='bi-layers'
        >
          <SidebarMenuItem
            to='/stakeholders/stakeholders-and-investors'
            title={intl.formatMessage({ id: 'Shareholders & investors' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/stakeholders/board-member'
            title={intl.formatMessage({ id: 'Board Members' })}
            hasBullet={true}
            activePaths={[
              '/stakeholders/board-member',
              'stakeholders/board-member-details',
              '/stakeholders/add-board-member',
            ]}
          />
          <SidebarMenuItem
            to={'/stakeholders/founders-and-promoters'}
            title={intl.formatMessage({ id: 'Founders & Promoters' })}
            hasBullet={true}
            activePaths={[
              '/stakeholders/founders-and-promoters',
              '/stakeholders/add-founder-and-promoter',
              '/stakeholders/founder-and-promoter-details',
            ]}
          />
          <SidebarMenuItem
            to='/stakeholders/management-team'
            title={intl.formatMessage({ id: 'Management Team' })}
            hasBullet={true}
            activePaths={[
              '/stakeholders/management-team',
              '/stakeholders/add-team-member',
              '/stakeholders/team-member-detail',
            ]}
          />
          <SidebarMenuItem
            to='/stakeholders/legal-and-compliance'
            title={intl.formatMessage({ id: 'Legal & Compliance' })}
            hasBullet={true}
            activePaths={[
              '/stakeholders/legal-and-compliance',
              '/stakeholders/add-legal-and-compliance',
              '/stakeholders/individual-legal-compliance-details',
              '/stakeholders/institutional-legal-compliance-details',
            ]}
          />
          <SidebarMenuItem
            to='/stakeholders/finance-and-accounts'
            title={intl.formatMessage({ id: 'Finance & Accounts' })}
            hasBullet={true}
            activePaths={[
              '/stakeholders/finance-and-accounts',
              '/stakeholders/add-finance-and-accounts',
              '/stakeholders/individual-finance-accounts-details',
              '/stakeholders/institutional-finance-accounts-details',
            ]}
          />
          <SidebarMenuItem
            to='/stakeholders/advisors-and-mentors'
            title={intl.formatMessage({ id: 'Advisors & Mentors' })}
            hasBullet={true}
            activePaths={[
              '/stakeholders/advisors-and-mentors',
              '/stakeholders/add-advisors-and-mentors',
              '/stakeholders/individual-advisors-and-mentors-details',
              '/stakeholders/institutional-advisors-and-mentors-details',
            ]}
          />
        </SidebarMenuItemWithSub>
      )}

      {/* Compliance Meetings  */}
      {/* {moduleStatus['compliance-meeting'] !== false &&
        role &&
        role !== roleValues.BILLING &&
        role !== roleValues.CURATOR && ( */}
      {moduleStatus['compliance-meeting'] !== false && (
        <SidebarMenuItemWithSub
          to='/compliance-meeting'
          title={intl.formatMessage({ id: 'Compliance Meeting' })}
          icon='/media/icons/sidebar/v2/ic-compliance-meeting.svg'
          fontIcon='bi-person'
        >
          <SidebarMenuItem
            to='/compliance-meeting?tab=upcoming_meeting'
            title={intl.formatMessage({ id: 'Upcoming Meetings' })}
            hasBullet={true}
            activePaths={['/compliance-meeting?tab=upcoming_meeting']}
          />
          <SidebarMenuItem
            to='/compliance-meeting?tab=board_meeting'
            title={intl.formatMessage({ id: 'Board Meetings' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/compliance-meeting?tab=shareholders_meeting'
            title={intl.formatMessage({ id: 'Shareholders Meetings' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/compliance-meeting?tab=other_meeting'
            title={intl.formatMessage({ id: 'Other Meetings' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/compliance-meeting?tab=past_meeting'
            title={intl.formatMessage({ id: 'Past Meetings' })}
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )}

      {/* CapTable Management  */}
      {/* {moduleStatus['captable-management'] !== false &&
        role &&
        role !== roleValues.BILLING &&
        role !== roleValues.CURATOR && ( */}
      {moduleStatus['captable-management'] !== false && (
        <SidebarMenuItemWithSub
          to='/captable-management'
          icon='/media/icons/sidebar/v3/ic-captable-management.svg'
          title={intl.formatMessage({ id: 'Cap Table Management' })}
          fontIcon='bi-person'
        >
          <SidebarMenuItem
            to='captable-management/overview'
            title={intl.formatMessage({ id: 'Overview' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='captable-management/captable'
            title={intl.formatMessage({ id: 'Cap Table' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='captable-management/scenarios'
            title={intl.formatMessage({ id: 'Scenarios' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='captable-management/timeline'
            title={intl.formatMessage({ id: 'Timeline' })}
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )}

      {/* Shared Access  */}
      {/* {moduleStatus['shared-access'] !== false && role && role !== roleValues.BILLING && ( */}
      {/* {moduleStatus['shared-access'] !== false && (
        <SidebarMenuItemWithSub
          to='/shared-access'
          icon='/media/icons/sidebar/v2/ic-shared-access.svg'
          title={intl.formatMessage({ id: 'Shared Access' })}
          fontIcon='bi-layers'
        >
          <SidebarMenuItem
            to='/shared-access?tab=inbox'
            title={intl.formatMessage({ id: 'Inbox' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to={`shared-access?tab=calendar`}
            title={intl.formatMessage({ id: 'Calender' })}
            hasBullet={true}
            activePaths={['/shared-access?tab=calendar']}
          />
          <SidebarMenuItem
            to='/shared-access?tab=contacts'
            title={intl.formatMessage({ id: 'Contacts' })}
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )} */}

      {/*Company Profile*/}
      {/* Role Restrction .Currenrly for all the plan we have access  */}
      {/* {moduleStatus['company-page'] !== false && (role && role === roleValues.OWNER) && (
        <SidebarMenuItem
          to='/company-page/'
          icon='/media/icons/sidebar/v2/ic-company-page.svg'
          activeIcon='/media/icons/sidebar/v2/ic-company-page-active.svg'
          title={intl.formatMessage({ id: 'Company Page' })}
          fontIcon='bi-layers'
        // disabled={billingData?.subscription_items[0].item_price_id.split('-')[0] !== 'Platinum'}
        />
      )} */}

      {/*Settings, User/Profile/Billing*/}
      {moduleStatus['settings'] !== false && (
        <SidebarMenuItemWithSub
          to='/setting'
          icon='/media/icons/sidebar/v2/ic-settings.svg'
          title={intl.formatMessage({ id: 'Settings' })}
          fontIcon='bi-layers'
        >
          <SidebarMenuItem
            to='/setting/user-settings'
            title={intl.formatMessage({ id: 'User Settings' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/setting/company-settings'
            title={intl.formatMessage({ id: 'Company Settings' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/setting/my-companies'
            title={intl.formatMessage({ id: 'My Companies' })}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/setting/billing-invoice'
            title={intl.formatMessage({ id: 'Billing and Invoices' })}
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>
      )}

      {/*Resources*/}
      {/* <SidebarMenuItemWithSub
        to=''
        icon='/media/icons/sidebar/v2/ic-resources.svg'
        title={intl.formatMessage({ id: 'Resources' })}
        fontIcon='bi-layers'
      >
        {moduleStatus['resources'] !== false && role && role !== roleValues.BILLING && (
          <SidebarMenuItem
            to='/resources'
            title={intl.formatMessage({ id: 'Documents' })}
            hasBullet={true}
          />
        )}

        {moduleStatus['market-deals'] !== false && (
          <SidebarMenuItem
            to='/founder-market'
            title={intl.formatMessage({ id: 'Founder Market' })}
            hasBullet={true}
          />
        )}
      </SidebarMenuItemWithSub> */}

      {/* Support*/}
      {moduleStatus['support'] !== false && (
        <SidebarMenuItemWithSub
          to=''
          icon='/media/icons/sidebar/v2/ic-support.svg'
          title={intl.formatMessage({ id: 'Support' })}
          fontIcon='bi-layers'
        >
          <div className='menu-item'>
            <a
              className='menu-link without-sub'
              href={brandingConfig.productRoadmapLink}
              target='_blank'
              rel='noreferrer'
            >
              <span className='menu-bullet'>
                <span className='bullet bullet-dot'></span>
              </span>
              <span className='menu-title'>{intl.formatMessage({ id: 'Product Roadmap' })}</span>
            </a>
          </div>

          <div className='menu-item'>
            <a
              className='menu-link without-sub'
              href={brandingConfig.suggestFeatureLink}
              target='_blank'
              rel='noreferrer'
            >
              <span className='menu-bullet'>
                <span className='bullet bullet-dot'></span>
              </span>
              <span className='menu-title'>{intl.formatMessage({ id: 'Feature Request' })}</span>
            </a>
          </div>

          <div className='menu-item'>
            <a
              className='menu-link without-sub'
              href={brandingConfig.changeLogUrl}
              target='_blank'
              rel='noreferrer'
            >
              <span className='menu-bullet'>
                <span className='bullet bullet-dot'></span>
              </span>
              <span className='menu-title'>{intl.formatMessage({ id: 'Changelog' })}</span>
            </a>
          </div>

          <div className='menu-item'>
            <a
              className='menu-link without-sub'
              // href='https://help.foundercrate.com/?utm_source=app&utm_medium=support-menu'
              href={brandingConfig.helpDeskUrl}
              target='_blank'
              rel='noreferrer'
            >
              <span className='menu-bullet'>
                <span className='bullet bullet-dot'></span>
              </span>
              <span className='menu-title'>{intl.formatMessage({ id: 'Help Desk' })}</span>
            </a>
          </div>

          <div className='menu-item'>
            <a
              className='menu-link without-sub'
              href={brandingConfig.customerSupportUrl}
              rel='noreferrer'
            >
              <span className='menu-bullet'>
                <span className='bullet bullet-dot'></span>
              </span>
              <span className='menu-title'>{intl.formatMessage({ id: 'Customer Support' })}</span>
            </a>
          </div>
          {/* <SidebarMenuItem
            to='/support/admin-app'
            title={intl.formatMessage({ id: 'Admin App' })}
            hasBullet={true}
          /> */}
        </SidebarMenuItemWithSub>
      )}

      <BillingModal
        modalShow={isActive}
        setModalShow={setIsActive}
        currentState={currentState}
        setCurrentState={setCurrentState}
        selected={selected}
        setSelected={setSelected}
        currencyBill={currencyBill}
        setPrice={setPrice}
        upgrade={false}
      />
    </>
  )
}

export { SidebarMenuMainRecordskeeper }
